import { useTranslation } from 'react-i18next';

import AccountAccessForm from '@klaviyo-mkt/gatsby-components/organisms/form-account-access';
import ArticleMeta from '@klaviyo-mkt/gatsby-components/molecules/article-meta';
import GlobalHead from '../../components/head';
import Layout from '../../layout';
import * as s from './styles';

import type { HeadProps, PageProps } from 'gatsby';
import type { IPageContext } from '../../components/head/types';

export const AccountAccessRequest = ({ location, ...pageProps }: PageProps) => {
  const { t } = useTranslation();

  return (
    <Layout
      {...pageProps}
      headerChildren={(
        <s.SupportRequestHeader>
          <s.Breadcrumbs>
            <s.Breadcrumb to={t('organisms_forms_accountAccessForm_breadcrumb_href')}>{t('organisms_forms_accountAccessForm_breadcrumb_label')}</s.Breadcrumb>
            <s.Slash>/</s.Slash>
            <s.CurrentBreadcrumb>{t('organisms_forms_accountAccessForm_currentBreadcrumb')}</s.CurrentBreadcrumb>
          </s.Breadcrumbs>
          <ArticleMeta
            title={t('organisms_forms_accountAccessForm_articleMetaTitle')}
            topic='Support'
            topicSourceId='Support'
          />
        </s.SupportRequestHeader>
      )}
      location={location}
      showMoreCards={false}
    >
      <s.PageWrapper>
        <s.Header>
          <s.Title variant="h5Semibold" forwardedAs="h1">{t('organisms_forms_accountAccessForm_headline')}</s.Title>
          <s.Text variant='paragraph2'>{t('organisms_forms_accountAccessForm_subhead')}</s.Text>
        </s.Header>
        <s.FormContainer>
          <s.StyledForm>
            <AccountAccessForm backgroundColor='light' />
          </s.StyledForm>
        </s.FormContainer>
      </s.PageWrapper>
    </Layout>
  );
};

export default AccountAccessRequest;

export const Head = ({ location, pageContext }: HeadProps<null, IPageContext>) => (
  <GlobalHead
    langCode={pageContext?.locale}
    pathname={location.pathname}
    pageType='account'
  />
);
